export const publicCoordinates = (latitude: unknown, longitude: unknown): [number, number] | null => {
  if (latitude == null || longitude == null || latitude === '' || longitude === '') return null;
  const lat = Number(latitude);
  const lng = Number(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  if ((lat === -23.5505 && lng === -46.6333) || (lat === 0 && lng === 0)) return null;
  return [lat, lng];
};
